import { Drawer } from '@/global/components/Drawer'
import { useMediaQuery } from '@/global/hooks'
import { ClassName } from '@/global/types'
import classNames from 'classnames'
import { forwardRef, PropsWithChildren } from 'react'

interface MobileSettings {
  heightMode?: 'full' | 'half-bottom'
}

interface DesktopSettings {
  closeButton?: boolean
}

export interface ResponsiveModalProps {
  className?: ClassName
  id: string
  mobileSettings?: MobileSettings
  desktopSettings?: DesktopSettings
}

export const ResponsiveModal = forwardRef<
  HTMLDivElement,
  PropsWithChildren<ResponsiveModalProps>
>(function ResponsiveModal(
  {
    children,
    className,
    id,
    mobileSettings = { heightMode: 'full' },
    desktopSettings
  },
  ref
) {
  const isTabletLandscape = useMediaQuery({ maxWidth: 'tablet_landscape' })

  const mobileProps = {
    className: classNames(
      'flex lg:hidden h-[calc(100dvh-var(--app-header-height))]',
      mobileSettings?.heightMode === 'full' && 'top-[var(--app-header-height)]',
      mobileSettings?.heightMode === 'half-bottom' && 'bottom-0 !h-fit',
      className
    ),
    closeButton: true,
    fullWidth: true
  }

  const desktopProps = {
    className: classNames(
      'hidden lg:flex h-fit border-gl-border-width-xs border-sys-color-stroke-active',
      className
    ),
    rounded: true,
    closeButton: desktopSettings?.closeButton
  }

  return (
    <Drawer
      id={id}
      ref={ref}
      {...(isTabletLandscape ? mobileProps : desktopProps)}
    >
      {children}
    </Drawer>
  )
})
